<template>
  <div id="fy_grid" class="parent_container">
    <div v-for="(item,index) in grid" :key="'grid' + index" class="fy_grid_item">
      <div class="fy_grid_detail">
        <h2>{{item.title}}</h2>
        <p v-for="(h4,hIndex) in item.h4" :key="hIndex">{{h4}}</p>
      </div>
      <img :src="item.imgSrc">
    </div>
  </div>
</template>

<script>
  import './../assets/css/fy_container_grid.css'
  import grid from "../assets/conf/hard_grid"
    export default {
        name: "fy_container_grid",
        data() {
            return {
                grid
            }
        },
        mounted() {
            console.log(this.grid)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_container_grid.vue